const secJcamp1 = `

##TITLE=Spectrum1
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SIZE EXCLUSION CHROMATOGRAPHY
##DATA CLASS=NTUPLES
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=G/MOL
##YUNITS=ARBITRARY UNITS
##SAMPLE=Vial   1: MS139 - 1
##MN= 7.997E+3
##MW= 8.643E+3
##D= 1.081E+0
##MP= 8.736E+3
##DETEC1=I2: RI Detector 1, RI Signal
##DETEC2=I2: UV Detector 1, UV Signal
##DETEC3=I2: Pump 1, Sample Pump Pressure
##COL1=PSS SDV 5m
##COL2=PSS SDV 5µm
##COL3=PSS SDV 5µm
##IN_VOL= 50.000
##ELUENT=THF
##FLOW=  1.000
##TEMPERATURE= 35.000
##DATE=23.07.21
##TIME=02:05:58
##FIRSTX=1.17562E+3
##LASTX=3.82890E+4
##MINX=1175.62
##MAXX=38289.0
##MINY=0.0
##MAXY=1.74729
##NPOINTS=376
##FIRSTY=0.00000E+0
##XUNITS=G/MOL
##YUNITS=ARBITRARY UNITS
##XYDATA=(XY..XY)
1.17562E+3, 0.00000E+0
1.18659E+3, 1.85399E-3
1.19766E+3, 6.40963E-3
1.20884E+3, 9.40598E-3
1.22012E+3, 1.22682E-2
1.23151E+3, 1.50615E-2
1.24300E+3, 1.92948E-2
1.25460E+3, 2.17525E-2
1.26631E+3, 2.49598E-2
1.27812E+3, 2.67075E-2
1.29005E+3, 2.91379E-2
1.30209E+3, 2.55007E-2
1.31424E+3, 2.34387E-2
1.32651E+3, 2.05639E-2
1.33889E+3, 1.86721E-2
1.35138E+3, 1.59687E-2
1.36399E+3, 1.43775E-2
1.37672E+3, 1.32030E-2
1.38957E+3, 1.41037E-2
1.40254E+3, 1.51166E-2
1.41563E+3, 1.86661E-2
1.42884E+3, 2.12719E-2
1.44217E+3, 2.60711E-2
1.45563E+3, 3.02468E-2
1.46922E+3, 3.49441E-2
1.48293E+3, 4.02415E-2
1.49677E+3, 4.45265E-2
1.51073E+3, 4.70402E-2
1.52483E+3, 4.98229E-2
1.53906E+3, 5.06037E-2
1.55343E+3, 5.04642E-2
1.56792E+3, 4.95199E-2
1.58255E+3, 4.73887E-2
1.59732E+3, 4.54034E-2
1.61223E+3, 4.31121E-2
1.62728E+3, 4.42511E-2
1.64246E+3, 4.51619E-2
1.65779E+3, 4.65172E-2
1.67326E+3, 4.97951E-2
1.68888E+3, 5.47132E-2
1.70464E+3, 5.93065E-2
1.72055E+3, 6.55776E-2
1.73660E+3, 7.01925E-2
1.75281E+3, 7.61391E-2
1.76917E+3, 7.86879E-2
1.78568E+3, 8.17690E-2
1.80234E+3, 8.32793E-2
1.81916E+3, 8.32897E-2
1.83614E+3, 8.28231E-2
1.85327E+3, 8.26132E-2
1.87057E+3, 8.20695E-2
1.88802E+3, 8.37694E-2
1.90564E+3, 8.50859E-2
1.92343E+3, 8.86827E-2
1.94138E+3, 9.38510E-2
1.95950E+3, 9.97711E-2
1.97778E+3, 1.05577E-1
1.99624E+3, 1.10671E-1
2.01487E+3, 1.15467E-1
2.03367E+3, 1.19366E-1
2.05265E+3, 1.22320E-1
2.07181E+3, 1.24421E-1
2.09114E+3, 1.25309E-1
2.11066E+3, 1.25595E-1
2.13035E+3, 1.27529E-1
2.15023E+3, 1.29376E-1
2.17030E+3, 1.34253E-1
2.19055E+3, 1.39849E-1
2.21100E+3, 1.43914E-1
2.23163E+3, 1.48930E-1
2.25246E+3, 1.56118E-1
2.27348E+3, 1.61781E-1
2.29469E+3, 1.66892E-1
2.31611E+3, 1.69601E-1
2.33772E+3, 1.73668E-1
2.35954E+3, 1.76135E-1
2.38156E+3, 1.79453E-1
2.40379E+3, 1.82669E-1
2.42622E+3, 1.86938E-1
2.44886E+3, 1.92593E-1
2.47171E+3, 2.00086E-1
2.49478E+3, 2.04603E-1
2.51806E+3, 2.09642E-1
2.54156E+3, 2.14496E-1
2.56528E+3, 2.20645E-1
2.58922E+3, 2.25789E-1
2.61338E+3, 2.30347E-1
2.63777E+3, 2.35210E-1
2.66239E+3, 2.39788E-1
2.68723E+3, 2.45058E-1
2.71231E+3, 2.51215E-1
2.73762E+3, 2.57207E-1
2.76317E+3, 2.64166E-1
2.78896E+3, 2.71053E-1
2.81499E+3, 2.77604E-1
2.84126E+3, 2.83856E-1
2.86777E+3, 2.89808E-1
2.89454E+3, 2.96140E-1
2.92155E+3, 3.02956E-1
2.94881E+3, 3.09796E-1
2.97633E+3, 3.15884E-1
3.00411E+3, 3.23164E-1
3.03214E+3, 3.30908E-1
3.06044E+3, 3.38126E-1
3.08900E+3, 3.45937E-1
3.11783E+3, 3.53684E-1
3.14692E+3, 3.60937E-1
3.17629E+3, 3.68522E-1
3.20593E+3, 3.76263E-1
3.23585E+3, 3.85027E-1
3.26605E+3, 3.94429E-1
3.29653E+3, 4.03608E-1
3.32729E+3, 4.12539E-1
3.35835E+3, 4.19853E-1
3.38969E+3, 4.27945E-1
3.42132E+3, 4.36859E-1
3.45325E+3, 4.45704E-1
3.48547E+3, 4.54818E-1
3.51800E+3, 4.64410E-1
3.55083E+3, 4.74263E-1
3.58397E+3, 4.83747E-1
3.61742E+3, 4.93907E-1
3.65118E+3, 5.05009E-1
3.68525E+3, 5.15172E-1
3.71964E+3, 5.25859E-1
3.75435E+3, 5.36431E-1
3.78939E+3, 5.47564E-1
3.82475E+3, 5.57808E-1
3.86045E+3, 5.68602E-1
3.89647E+3, 5.79774E-1
3.93284E+3, 5.91583E-1
3.96954E+3, 6.03589E-1
4.00658E+3, 6.15462E-1
4.04398E+3, 6.27195E-1
4.08171E+3, 6.39854E-1
4.11981E+3, 6.51687E-1
4.15825E+3, 6.64204E-1
4.19706E+3, 6.76426E-1
4.23623E+3, 6.90114E-1
4.27576E+3, 7.03527E-1
4.31566E+3, 7.17067E-1
4.35594E+3, 7.30612E-1
4.39659E+3, 7.44494E-1
4.43762E+3, 7.58499E-1
4.47903E+3, 7.73035E-1
4.52083E+3, 7.87375E-1
4.56302E+3, 8.01579E-1
4.60560E+3, 8.15495E-1
4.64859E+3, 8.30347E-1
4.69197E+3, 8.44713E-1
4.73575E+3, 8.59416E-1
4.77995E+3, 8.74540E-1
4.82456E+3, 8.90004E-1
4.86958E+3, 9.05104E-1
4.91503E+3, 9.19504E-1
4.96089E+3, 9.35122E-1
5.00719E+3, 9.50978E-1
5.05392E+3, 9.66996E-1
5.10108E+3, 9.82110E-1
5.14869E+3, 9.98127E-1
5.19674E+3, 1.01391E+0
5.24523E+3, 1.03014E+0
5.29418E+3, 1.04678E+0
5.34359E+3, 1.06315E+0
5.39346E+3, 1.07894E+0
5.44379E+3, 1.09508E+0
5.49459E+3, 1.11119E+0
5.54587E+3, 1.12699E+0
5.59763E+3, 1.14286E+0
5.64987E+3, 1.15878E+0
5.70259E+3, 1.17476E+0
5.75581E+3, 1.19069E+0
5.80952E+3, 1.20680E+0
5.86374E+3, 1.22265E+0
5.91846E+3, 1.23857E+0
5.97369E+3, 1.25417E+0
6.02944E+3, 1.26939E+0
6.08571E+3, 1.28448E+0
6.14250E+3, 1.30105E+0
6.19983E+3, 1.31739E+0
6.25769E+3, 1.33241E+0
6.31609E+3, 1.34699E+0
6.37503E+3, 1.36162E+0
6.43452E+3, 1.37578E+0
6.49457E+3, 1.38977E+0
6.55518E+3, 1.40442E+0
6.61635E+3, 1.41919E+0
6.67810E+3, 1.43404E+0
6.74042E+3, 1.44795E+0
6.80333E+3, 1.46187E+0
6.86682E+3, 1.47576E+0
6.93090E+3, 1.48953E+0
6.99558E+3, 1.50268E+0
7.06086E+3, 1.51562E+0
7.12676E+3, 1.52849E+0
7.19327E+3, 1.54089E+0
7.26040E+3, 1.55310E+0
7.32815E+3, 1.56518E+0
7.39654E+3, 1.57720E+0
7.46557E+3, 1.58873E+0
7.53524E+3, 1.60021E+0
7.60556E+3, 1.61130E+0
7.67654E+3, 1.62181E+0
7.74818E+3, 1.63223E+0
7.82048E+3, 1.64214E+0
7.89347E+3, 1.65290E+0
7.96713E+3, 1.66419E+0
8.04148E+3, 1.67229E+0
8.11653E+3, 1.67836E+0
8.19227E+3, 1.68580E+0
8.26872E+3, 1.69381E+0
8.34589E+3, 1.70251E+0
8.42378E+3, 1.70962E+0
8.50239E+3, 1.71505E+0
8.58174E+3, 1.72055E+0
8.66182E+3, 1.72555E+0
8.74266E+3, 1.73163E+0
8.82425E+3, 1.73500E+0
8.90660E+3, 1.73893E+0
8.98972E+3, 1.74148E+0
9.07361E+3, 1.74436E+0
9.15829E+3, 1.74640E+0
9.24375E+3, 1.74709E+0
9.33002E+3, 1.74729E+0
9.41709E+3, 1.74701E+0
9.50497E+3, 1.74657E+0
9.59368E+3, 1.74496E+0
9.68321E+3, 1.74297E+0
9.77357E+3, 1.74056E+0
9.86478E+3, 1.73727E+0
9.95684E+3, 1.73313E+0
1.00498E+4, 1.72833E+0
1.01435E+4, 1.72315E+0
1.02382E+4, 1.71711E+0
1.03338E+4, 1.71032E+0
1.04302E+4, 1.70272E+0
1.05275E+4, 1.69409E+0
1.06258E+4, 1.68593E+0
1.07249E+4, 1.67664E+0
1.08250E+4, 1.66688E+0
1.09261E+4, 1.65614E+0
1.10280E+4, 1.64561E+0
1.11309E+4, 1.63340E+0
1.12348E+4, 1.62099E+0
1.13397E+4, 1.60839E+0
1.14455E+4, 1.59472E+0
1.15523E+4, 1.58019E+0
1.16601E+4, 1.56529E+0
1.17689E+4, 1.55029E+0
1.18787E+4, 1.53548E+0
1.19896E+4, 1.51881E+0
1.21015E+4, 1.50217E+0
1.22144E+4, 1.48397E+0
1.23284E+4, 1.46702E+0
1.24435E+4, 1.44887E+0
1.25596E+4, 1.43018E+0
1.26768E+4, 1.41090E+0
1.27951E+4, 1.39137E+0
1.29145E+4, 1.37185E+0
1.30350E+4, 1.35196E+0
1.31567E+4, 1.33166E+0
1.32795E+4, 1.31148E+0
1.34034E+4, 1.29075E+0
1.35285E+4, 1.27044E+0
1.36547E+4, 1.24947E+0
1.37822E+4, 1.22915E+0
1.39108E+4, 1.20767E+0
1.40406E+4, 1.18659E+0
1.41716E+4, 1.16573E+0
1.43039E+4, 1.14436E+0
1.44374E+4, 1.12240E+0
1.45721E+4, 1.10036E+0
1.47081E+4, 1.07843E+0
1.48453E+4, 1.05659E+0
1.49839E+4, 1.03466E+0
1.51237E+4, 1.01374E+0
1.52649E+4, 9.92451E-1
1.54073E+4, 9.71767E-1
1.55511E+4, 9.50791E-1
1.56962E+4, 9.29765E-1
1.58427E+4, 9.08993E-1
1.59906E+4, 8.88165E-1
1.61398E+4, 8.67533E-1
1.62904E+4, 8.47151E-1
1.64424E+4, 8.27247E-1
1.65959E+4, 8.07650E-1
1.67508E+4, 7.86965E-1
1.69071E+4, 7.66748E-1
1.70649E+4, 7.46775E-1
1.72241E+4, 7.27255E-1
1.73849E+4, 7.08609E-1
1.75471E+4, 6.89001E-1
1.77108E+4, 6.70706E-1
1.78761E+4, 6.52501E-1
1.80430E+4, 6.34943E-1
1.82113E+4, 6.17884E-1
1.83813E+4, 6.01103E-1
1.85528E+4, 5.84406E-1
1.87260E+4, 5.67227E-1
1.89007E+4, 5.49157E-1
1.90771E+4, 5.33289E-1
1.92551E+4, 5.16355E-1
1.94348E+4, 5.00513E-1
1.96162E+4, 4.84851E-1
1.97993E+4, 4.69642E-1
1.99840E+4, 4.54378E-1
2.01705E+4, 4.38687E-1
2.03588E+4, 4.23763E-1
2.05488E+4, 4.09432E-1
2.07405E+4, 3.95485E-1
2.09341E+4, 3.81460E-1
2.11295E+4, 3.67190E-1
2.13266E+4, 3.53321E-1
2.15257E+4, 3.39856E-1
2.17266E+4, 3.26267E-1
2.19293E+4, 3.14267E-1
2.21340E+4, 3.01738E-1
2.23405E+4, 2.90108E-1
2.25490E+4, 2.78187E-1
2.27594E+4, 2.66067E-1
2.29718E+4, 2.53987E-1
2.31862E+4, 2.42056E-1
2.34026E+4, 2.31013E-1
2.36210E+4, 2.21054E-1
2.38414E+4, 2.10826E-1
2.40639E+4, 2.00672E-1
2.42885E+4, 1.89948E-1
2.45152E+4, 1.79247E-1
2.47439E+4, 1.70272E-1
2.49749E+4, 1.60589E-1
2.52079E+4, 1.52455E-1
2.54432E+4, 1.43748E-1
2.56806E+4, 1.35565E-1
2.59203E+4, 1.27760E-1
2.61622E+4, 1.19859E-1
2.64063E+4, 1.12609E-1
2.66528E+4, 1.06123E-1
2.69015E+4, 9.99014E-2
2.71525E+4, 9.30753E-2
2.74059E+4, 8.57045E-2
2.76617E+4, 7.86274E-2
2.79198E+4, 7.29402E-2
2.81804E+4, 6.68288E-2
2.84434E+4, 6.25013E-2
2.87088E+4, 5.76120E-2
2.89767E+4, 5.30518E-2
2.92472E+4, 4.89891E-2
2.95201E+4, 4.44420E-2
2.97956E+4, 4.10638E-2
3.00737E+4, 3.74342E-2
3.03543E+4, 3.33414E-2
3.06376E+4, 2.97255E-2
3.09235E+4, 2.67727E-2
3.12121E+4, 2.37648E-2
3.15034E+4, 2.21808E-2
3.17974E+4, 1.91810E-2
3.20941E+4, 1.72868E-2
3.23936E+4, 1.56175E-2
3.26959E+4, 1.36311E-2
3.30011E+4, 1.26126E-2
3.33090E+4, 1.08721E-2
3.36199E+4, 9.61450E-3
3.39336E+4, 8.37692E-3
3.42503E+4, 7.03945E-3
3.45699E+4, 5.77990E-3
3.48926E+4, 5.25796E-3
3.52182E+4, 3.64103E-3
3.55468E+4, 3.14309E-3
3.58786E+4, 2.69469E-3
3.62134E+4, 2.04130E-3
3.65514E+4, 2.15395E-3
3.68925E+4, 8.01765E-4
3.72368E+4, 6.58252E-4
3.75843E+4, 3.85349E-4
3.79350E+4, 9.43752E-6
3.82890E+4, 0.00000E+0
##END=$$ End of the data block

`;

export default secJcamp1;
